import View from './View.js';

class NavigationView extends View {
  _navClickActions(btn) {
    //btn.style.opacity = 0;

    const search = document.querySelector('.search');
    const results = document.querySelector('.results');
    const pagination = document.querySelector('.pagination');
    const copyright = document.querySelector('.copyright');
    const recipeOverlay = document.querySelector('.recipe-overlay');

    //hiding search and results
    search.classList.add('hide-search');
    results.classList.add('hide-search');
    pagination.classList.add('hide-search');
    copyright.classList.add('hide-search');

    document.querySelector('.search-results').classList.toggle('hide');

    if (recipeOverlay.classList.contains('hide-search')) {
      //add recipe overlay
      recipeOverlay.classList.remove('hide-search');
    } else {
      setTimeout(() => {
        //add recipe overlay
        recipeOverlay.classList.add('hide-search');
      }, 400);
    }

    /* //hide nav btn for 500 mili sec
    setTimeout(() => {
      btn.style.opacity = 1;
    }, 500); */

    //unhiding search and results after 600 mili sec
    setTimeout(() => {
      search.classList.remove('hide-search');
      results.classList.remove('hide-search');
      pagination.classList.remove('hide-search');
      copyright.classList.remove('hide-search');
    }, 400);
  }

  showNavOnClick(handler) {
    const clickAction = this._navClickActions;
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.sandwich');
      if (!btn) return;
      clickAction(btn);
      handler();
    });
  }

  closeNavOnOverlayClick(handler) {
    const clickAction = this._navClickActions;
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.recipe-overlay');
      if (!btn) return;
      clickAction(btn);
      handler();
    });
  }
}

export default new NavigationView();
